//lib
import * as React from "react";
import * as ReactDOM from "react-dom";

//components
import App from "./App";
//style
import "./index.scss";

//const
//
ReactDOM.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
  ,
  document.querySelector("#root")
);
